/* @flow */

import * as React from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import Localizer from '../../helpers/localization';
import { deleteSearchHistoryTerm } from '../../redux/ui/actions';
import { PictoReplay, PictoX } from '../pictos/Element';
import './SearchHistoryTerm.css';

type SearchHistoryTermPropType = {
  +onClick: (term: string) => void,
  +term: string,
};

const SearchHistoryTerm = ({ onClick, term }: SearchHistoryTermPropType): React.Node => {
  const dispatch = useDispatch();

  const handleSearchOnClick = useCallback(() => {
    onClick(term);
  }, [onClick, term]);

  const handleDeleteOnClick = useCallback(() => {
    dispatch(deleteSearchHistoryTerm(term));
  }, [term]);

  return (
    <div className='searchHistoryTerm'>
      <PictoReplay className='refresh' />
      <button aria-label={Localizer.localize('accessibility.navigation.search_again', { term })} className='term' onClick={handleSearchOnClick} type='button'>
        {term}
      </button>
      <button aria-label={Localizer.localize('accessibility.navigation.search_delete', { term })} className='delete' onClick={handleDeleteOnClick} type='button'>
        <PictoX forceHoverEffect />
      </button>
    </div>
  );
};

export default SearchHistoryTerm;
